import { HttpClient } from '@angular/common/http';
import { Injectable, inject, makeStateKey, TransferState, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Observable, of, tap } from 'rxjs';

import { environment } from '../../../../public/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private http = inject(HttpClient);
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);

  getHomePage(slug?: string): Observable<object | null> {
    if (!slug) {
      slug = 'denver';
    }

    const key = makeStateKey<object | null>(`theme-${slug}`);

    if (this.transferState.hasKey(key)) {
      const cached = this.transferState.get(key, null);
      this.transferState.remove(key); // avoid stale reuse on client-side nav
      return of(cached);
    }

    console.log('Fetching theme data for slug:', `${environment.URL}/themes/${slug}.json`);

    return this.http.get<object | null>(`${environment.URL}/themes/${slug}.json`).pipe(
      tap((data) => {
        if (isPlatformServer(this.platformId)) {
          this.transferState.set(key, data);
        }
      }),
    );
  }
}
